import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { IMenuItem, NavigationService } from 'src/app/services/navigation.service';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { LookupsService } from 'src/app/services/lookups.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  // animations: [
  //   trigger('contentExpansion', [
  //     state('expanded', style({ height: '*', opacity: 1, visibility: 'visible' })),
  //     state('collapsed', style({ height: '0px', opacity: 0, visibility: 'hidden' })),
  //     transition('expanded <=> collapsed',
  //       animate('200ms cubic-bezier(.37,1.04,.68,.98)')),
  //   ])
  // ]
})
export class SidebarComponent implements OnInit {
  nav: any[] = [];
  selectedItem: IMenuItem | null = null;
  searchText: string = '';

  loading = true;

  restaurantName!: any;

  // Count down for License
  timeout: any;
  licenseExpiration!: any;
  outSideLinks: any[] = [];

  baseRoute = localStorage.getItem('baseRoute') || '/admin';
  constructor(
    public navService: NavigationService,
    public LookupsService: LookupsService,
    public authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef,
    public router: Router
  ) { }

  ngOnInit(): void {

    this.authenticationService.actionsPermissions.subscribe((data: any) => {
      this.licenseExpiration = data?.licenseExpiration;
      if (this.licenseExpiration) {
        this.handleExpirationCountdown();
      }
    });

    this.getMenuItems();
    // if (location.href.includes("localhost")) {
    //   this.navService.menuItems.subscribe(items => {
    //     this.nav = items;
    //   });
    // } else {
    //   this.getMenuItems();
    // }

    this.authenticationService.updateMenu.subscribe((data: any) => {
      if (data) {
        this.getMenuItems();
        // this.router.navigate([this.baseRoute]);
      }
    })
  }
  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  getMenuItems() {
    this.LookupsService.GetMenu().subscribe(
      (data: any) => {
        this.outSideLinks = data.outSideLinks;
        this.nav = data.menu as any[];
        this.nav.map(item => {
          item.title = item.name;
          item.type = item.childs && item.childs.length ? 'dropDown' : 'link';
          item.icon = item.svg;
          item.state = item.url;
          item.selected = item.childs?.some((c: any) => this.isActiveMenu(c.url));
          if (item.childs && item.childs.length) {
            item.sub = item.childs;
            item.sub.map((child: any) => {
              child.title = child.name;
              child.type = 'link';
              child.icon = child.svg;
              child.state = child.url;
            });
          }
        })
        this.authenticationService.menuLoaded.next(this.nav);
        setTimeout(() => {
          document.querySelector('.sidebar-list-menu li.active')?.scrollIntoView({
            block: "center", inline: "nearest"
          });
        }, 100);
        this.loading = false;
      },
      (error: any) => {
        this.authenticationService.logout();
      });
  }

  isActiveMenu(link: string) {
    return this.router.url.includes(link);
  }

  selectItem(item: IMenuItem) {
    // this.nav.map(n => {
    //   if (item.id != n.id && item.sub) n.selected = false;
    // });
    item.selected = !item.selected;
  }

  toggelSidebar() {
    const navState = this.navService.sidebarState;
    navState.sidenavOpen = !navState.sidenavOpen;
    this.navService.sidenavOpen.next(navState.sidenavOpen);
  }

  hideOption(item: any) {
    let hide = true;
    if (new RegExp(this.searchText, 'i').test(item.title)) {
      hide = false;
    }
    if (item.sub) {
      item.sub.forEach((child: any) => {
        child.hide = true;
        if (new RegExp(this.searchText, 'i').test(child.title)) {
          hide = false;
          child.hide = false;
        }
      });
      if (item.sub.every((x: any) => x.hide) && !hide) {
        item.sub.map((x: any) => x.hide = false);
      }
    }
    return hide;
  }

  counter(n: number) { return new Array(n) }

  handleExpirationCountdown() {
    const now = new Date();

    const tomorrow = new Date();
    tomorrow.setDate(now.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    const timeUntilMidnight = tomorrow.getTime() - now.getTime();

    this.timeout = setTimeout(() => {
      this.licenseExpiration = this.licenseExpiration! - 1;
    }, timeUntilMidnight);
  }


  ngOnDestroy(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
